import React from 'react'
import SearchNav from '../../SearchNav/SearchNav'

const Nodes = () => {
  return (
    <div>
        <SearchNav/>
        <h1 className='p-3'>
            Nodes
        </h1>
    </div>
  )
}

export default Nodes